<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
          <span class="fonints">车牌号码</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions.plate"
            clearable
          >
          </el-input>
          <span class="fonints">所属车队</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions.name"
            clearable
          >
          </el-input>
          <span class="fonints">超速路段</span>
          <div class="select_box1">
            <el-select v-model="conditions.electronicFenceName" class="m-2" clearable>
              <el-option
                v-for="item in fence_list"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <span class="fonints">时间</span>
          <el-date-picker
            v-model="conditions.startTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
            @change="handleStartTimeChange"
          ></el-date-picker>
          <span class="fonints">至</span>
          <el-date-picker
            v-model="conditions.endTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
            :picker-options="{ disabledDate }"
          ></el-date-picker>
        </div>
      </div>
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
          <span class="fonints" style="margin-right: 50px">
            超速车辆：{{ pagination.total }}辆</span
          >
        </div>
        <div class="componentSty_content_title_flex_button">
          <button class="buttons" style="color: #17B6A1;background-color: #F3F4F5;" @click="exportlist">导出</button>
          <button class="buttons" @click="selectlist">查询</button>
          <button class="buttons" @click="goback">返回</button>
        </div>
      </div>
      <div class="componentSty_content_table" style="top: 90px; border: none">
        <el-table
          :data="arrlist.list"
          style="width: 100%; height: 80%"
          border
          height="80%"
        >
          <el-table-column
            show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="shortname"
            label="所属车队"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            sortable="custom"
            label="超速时间"
            prop="gmt_create"
          >
            <template v-slot="res">
              {{ mydateFormat(res.row.alarmtimeCreate, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="speed"
            label="时速(km/时)"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="electronicFenceName"
            label="超速路段"
          >
          </el-table-column>
        </el-table>
        <div class="paginations">
          <el-pagination
            :page-size="pagination.pageSize"
            :current-page="pagination.currentPage"
            layout="total,prev, pager,next, jumper"
            :total="pagination.total"
            @current-change="getMemberlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake, printExcel} from "@/plugins/other.js";
import dayjs from "dayjs";
export default {
  data() {
    return {
      pagination: {
        pageSize: 20,

        total: 0,
      },
      listitem: [{ name: "车辆管理" }, { name: "超速详情" }],
      timeout: null,
      conditions: {
        page: 1,
        limit: 20,
        plate: "",
        endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        startTime: dayjs().subtract(6, "hour").format("YYYY-MM-DD HH:mm:ss"),
      },
      arrlist: [],
      dateinfo: [],
      dischargeoptions: [],
      fence_list: [],
    };
  },
  components: {
    mTitle,
  },
  created() {
    this.getMemberlist();
    this.getData()
  },
  methods: {
    async getData() {
      try {
        const { data } = await this.$http(
          "api1",
          "/electronicfence/fence/list",
          "get",
          {
            limit: this.pagination.pageSize,
            page: this.pagination.currentPage,
            status: 0,
          }
        );
        console.log("data: ", data);
        this.fence_list = data.data.list.map((item) => {
          return item.electronicFenceName;
        });
        this.pagination.total = data.data.totalCount;
      } catch (error) {
        console.log("error", error);
        this.fence_list = [];
      }
    },
    goback() {
      this.$router.go(-1);
    },
    handleStartTimeChange(value) {
      this.conditions.startTime = value;
      this.conditions.endTime = null;
    },
    disabledDate(time) {
      if (!this.conditions.startTime) {
        return false;
      }
      const sixHoursLater =
        this.conditions.startTime.getTime() + 6 * 60 * 60 * 1000;
      return (
        time.getTime() > sixHoursLater ||
        time.getTime() < this.conditions.startTime.getTime()
      );
    },
    async getMemberlist(num) {
      this.conditions.startTime = this.conditions.startTime
        ? dayjs(this.conditions.startTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
      this.conditions.endTime = this.conditions.endTime
        ? dayjs(this.conditions.endTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/api/replenish/DriverCarSpeedAlarm/list",
        "get",
        this.conditions
      );
      if (!data || data.code != 0)
        return this.$message.error(data.msg || "获取数据失败");
      this.arrlist = data.data;
      this.pagination.total = data.data.totalCount;
    },
    // itemparticulars(res) {
    //   window.sessionStorage.setItem("infoid", res.id);
    //   this.$router.push({ name: "newaddparticulars" });
    // },
    // sortchange(event) {
    //   if (event.prop) this.conditions.sidx = event.prop;
    //   if (event.order == "ascending") {
    //     this.conditions.sidx = event.prop;
    //     this.conditions.order = "asc";
    //   } else if (event.order == "descending") {
    //     this.conditions.sidx = event.prop;
    //     this.conditions.order = "desc";
    //   } else {
    //     this.conditions.sidx = "";
    //     this.conditions.order = "";
    //   }
    //   this.getMemberlist();
    // },
    exportlist(){
      this.conditions.startTime = this.conditions.startTime
        ? dayjs(this.conditions.startTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
      this.conditions.endTime = this.conditions.endTime
        ? dayjs(this.conditions.endTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
      this.conditions.page = null;
      this.conditions.limit = null
      printExcel.call(
        this,
        '/api/replenish/DriverCarSpeedAlarm/exportCarSpeedAlarmlist',
        '超速记录',
        this.conditions,
        'post'
      );
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getMemberlist();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
<style lang="scss">
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px !important;
}
</style>